import { Fragment, useEffect, useRef, useContext } from 'react'
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock'
import { Stack, Text, Spinner, Card } from '@leroy-merlin-br/backyard-react-ui'

import { OptionFilterItem, FilterTitle } from '../Filters/components'
import { EntryKeyContext } from '../../context/EntryKeyContext'
import { Header, Footer } from './components'
import { Accordion, AppliedFilters, Facets, SwitchFilter, Sorters } from '../'
import * as S from './styled'

const EntryKeyMobileFilters = () => {
  const {
    filters,
    filterUsedOptions,
    onOptionClick,
    isMobileFilterActive,
    query: filtersQuery,
    baseUrl,
    isMappedSearch,
    hasHighlightedFilters,
    isLoading,
    isLoadingProducts,
    hasError
  } = useContext(EntryKeyContext)

  const ref = useRef()

  const shouldRenderLoading = (isLoading || isLoadingProducts) && !hasError

  useEffect(() => {
    isMobileFilterActive
      ? disableBodyScroll(ref.current)
      : enableBodyScroll(ref.current)

    return clearAllBodyScrollLocks
  }, [isMobileFilterActive])

  return (
    <Fragment>
      {shouldRenderLoading && (
        <S.Overlay>
          <Spinner color="green" size="zetta" />
        </S.Overlay>
      )}

      <S.MobileFilters isOpen={isMobileFilterActive}>
        <Header />
        <S.FiltersContainer ref={ref}>
          <Stack spacing="bit">
            <Accordion title="Ordenar por">
              <Sorters />
            </Accordion>

            {filterUsedOptions?.length && (
              <Card>
                <AppliedFilters />
              </Card>
            )}

            <Card>
              <SwitchFilter
                optionClick={{
                  name: 'produtos',
                  value: 'ofertas',
                  type: 'sorter',
                  dataLayerOptions: {
                    filter: 'Ofertas',
                    filterType: { index: 0, value: 'Ofertas' },
                    filterElement: { index: 0, value: 'Ofertas' }
                  }
                }}
              >
                <Text size="giga" bold noMargin>
                  Somente ofertas
                </Text>
              </SwitchFilter>
            </Card>

            {hasHighlightedFilters && (
              <Accordion title="Listar Produtos Com">
                <Facets />
              </Accordion>
            )}

            {filters.map((filter, filterTypeIndex) => (
              <Accordion
                key={filter.filterKey}
                title={<FilterTitle filter={filter} />}
              >
                {filter.options.map(
                  ({ query, label: optionLabel, quantity }, index) => (
                    <OptionFilterItem
                      key={`${query}-${filter.selected}`}
                      filterKey={filter.filterKey}
                      name={filter.name}
                      query={query}
                      optionLabel={optionLabel}
                      quantity={quantity}
                      selected={filter.selected}
                      onFilterClick={onOptionClick}
                      filtersQuery={filtersQuery}
                      url={baseUrl}
                      isMappedSearch={isMappedSearch}
                      filterElementIndex={index}
                      filterTypeIndex={filterTypeIndex}
                    />
                  )
                )}
              </Accordion>
            ))}
          </Stack>
        </S.FiltersContainer>
        <Footer />
      </S.MobileFilters>
    </Fragment>
  )
}

export default EntryKeyMobileFilters
